// Section-based keyboard navigation for landing pages
document.addEventListener('DOMContentLoaded', function() {
  // Target specific sections that need improved keyboard accessibility
  const sectionTypes = [
    '.featured-collection',
    '.product-grid',
    '.slide-section',
    '.collection-list',
    '.image-with-text',
    '.rich-text',
    '.hero-banner',
    '.image-gallery',
    '.testimonial',
    '.reviewsio-carousel',
    '#reviewsio-carousel-widget',
    '.custom_review_widget',
    '[id^="ReviewsWidget"]',
    '.jdgm-widget',
    '.jdgm-review-widget',
    'section'
  ];
  
  const sections = document.querySelectorAll(sectionTypes.join(', '));
  
  // Initialize sections for keyboard navigation
  sections.forEach((section, index) => {
    // Skip if already processed
    if (section.hasAttribute('data-a11y-section-enhanced')) return;
    
    // Mark as processed
    section.setAttribute('data-a11y-section-enhanced', 'true');
    
    // Find and process slider controls to make them initially unfocusable
    const sliderControls = section.querySelectorAll('.splide__arrow, .splide__pagination__page, .slider-controls button, .slider-navigation button, .slider-pagination button');
    sliderControls.forEach(control => {
      // Save original tabindex if exists
      if (!control.hasAttribute('data-original-tabindex')) {
        control.setAttribute('data-original-tabindex', control.getAttribute('tabindex') || '0');
        // Make initially unfocusable
        control.setAttribute('tabindex', '-1');
      }
    });
    
    // Find and make review elements initially unfocusable
    const reviewElements = section.querySelectorAll('.custom_review_widget a, .custom_review_widget button, .jdgm-rev a, .jdgm-rev button, .review a, .review button, .reviewsio-carousel a, .reviewsio-carousel button, [class*="reviews"] a, [class*="reviews"] button, [id*="review"] a, [id*="review"] button, [id*="Reviews"] a, [id*="Reviews"] button');
    
    reviewElements.forEach(element => {
      if (!element.hasAttribute('data-original-tabindex')) {
        element.setAttribute('data-original-tabindex', element.getAttribute('tabindex') || '0');
        // Make initially unfocusable
        element.setAttribute('tabindex', '-1');
      }
    });
    
    // Create the section tabindex wrapper if it doesn't exist
    if (!section.querySelector('.section-keyboard-wrapper')) {
      // Find heading to use as label
      let sectionHeading = section.querySelector('h1, h2, h3, h4, .sd-heading, .headline');
      const headingText = sectionHeading ? sectionHeading.textContent.trim() : `Section ${index + 1}`;
      
      // Create the wrapper element for the section
      const wrapper = document.createElement('div');
      wrapper.classList.add('section-keyboard-wrapper');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', `${headingText} section, press Enter to explore content`);
      
      // Setup the styling for focus state
      wrapper.style.position = 'absolute';
      wrapper.style.inset = '0';
      wrapper.style.zIndex = '2'; // Very low z-index so it doesn't block product links
      wrapper.style.outline = 'none';
      wrapper.style.pointerEvents = 'none';
      
      // Get all focusable elements within the section, excluding slider controls and review elements
      const focusableElements = Array.from(section.querySelectorAll(
        'a[href]:not(.custom_review_widget a):not(.jdgm-rev a):not(.review a):not(.reviewsio-carousel a):not([class*="reviews"] a):not([id*="review"] a):not([id*="Reviews"] a), ' +
        'button:not(.splide__arrow):not(.splide__pagination__page):not(.slider-controls button):not(.slider-navigation button):not(.slider-pagination button):not(.custom_review_widget button):not(.jdgm-rev button):not(.review button):not(.reviewsio-carousel button):not([class*="reviews"] button):not([id*="review"] button):not([id*="Reviews"] button), ' + 
        'input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ));
      
      // Set initial tabindex to -1 for all focusable elements
      focusableElements.forEach(el => {
        if (!el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
          el.setAttribute('tabindex', '-1');
        }
      });
      
      // Position the section wrapper properly
      if (getComputedStyle(section).position === 'static') {
        section.style.position = 'relative';
      }
      
      // Append the wrapper to the section
      section.appendChild(wrapper);
      
      // Add keyboard navigation to the section wrapper
      wrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          
          // Show focus styles for the section
          section.classList.add('section-focus');
          this.style.display = 'none';
          
          // Enable tabbing within the section - for regular elements
          const firstFocusableElement = focusableElements[0];
          if (firstFocusableElement) {
            focusableElements.forEach(el => {
              el.setAttribute('tabindex', el.getAttribute('data-original-tabindex') || '0');
            });
            
            // Also enable tabbing for slider controls when entering the section
            sliderControls.forEach(control => {
              control.setAttribute('tabindex', control.getAttribute('data-original-tabindex') || '0');
              
              // Make sure keyboard users can activate the controls
              if (!control.hasAttribute('data-keyboard-enhanced')) {
                control.setAttribute('data-keyboard-enhanced', 'true');
                
                control.addEventListener('keydown', function(e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                  }
                });
              }
            });
            
            // Also enable tabbing for review elements when entering the section
            reviewElements.forEach(element => {
              element.setAttribute('tabindex', element.getAttribute('data-original-tabindex') || '0');
              
              // Make sure keyboard users can activate the review elements
              if (!element.hasAttribute('data-keyboard-enhanced')) {
                element.setAttribute('data-keyboard-enhanced', 'true');
                
                element.addEventListener('keydown', function(e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                  }
                });
              }
            });
            
            // Focus the first element
            setTimeout(() => {
              firstFocusableElement.focus();
            }, 10);
          }
          
          // Handle leaving the section with Escape key
          const escapeHandler = function(escEvent) {
            if (escEvent.key === 'Escape') {
              // Restore the section wrapper
              wrapper.style.display = '';
              
              // Disable tabbing within the section
              focusableElements.forEach(el => {
                el.setAttribute('tabindex', '-1');
              });
              
              // Also disable slider controls when leaving the section
              sliderControls.forEach(control => {
                control.setAttribute('tabindex', '-1');
              });
              
              // Also disable review elements when leaving the section
              reviewElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
              });
              
              // Remove focus styles
              section.classList.remove('section-focus');
              
              // Focus back on the wrapper
              wrapper.focus();
              
              // Remove the escape listener
              document.removeEventListener('keydown', escapeHandler);
            }
          };
          
          // Add escape handler
          document.addEventListener('keydown', escapeHandler);
        }
      });
      
      // Style focus state of the section
      wrapper.addEventListener('focus', function() {
        section.classList.add('section-keyboard-focus');
        section.style.outline = '3px solid #5F9353';
        section.style.outlineOffset = '4px';
      });
      
      wrapper.addEventListener('blur', function() {
        section.classList.remove('section-keyboard-focus');
        section.style.outline = '';
        section.style.outlineOffset = '';
      });
    }
  });
  
  
  // Look for review sections specifically and enhance them
  const reviewSections = document.querySelectorAll('.testimonial, .reviewsio-carousel, #reviewsio-carousel-widget, [id^="ReviewsWidget"], .custom_review_widget, .jdgm-widget, .jdgm-review-widget');
  
  reviewSections.forEach(section => {
    // Skip if already processed for reviews
    if (section.hasAttribute('data-a11y-reviews-enhanced')) return;
    
    // Mark as processed
    section.setAttribute('data-a11y-reviews-enhanced', 'true');
    
    // Make sure the section has proper positioning for the wrapper
    if (getComputedStyle(section).position === 'static') {
      section.style.position = 'relative';
    }
    
    // Get all review cards/items within the section
    const reviewItems = section.querySelectorAll('.jdgm-rev, .review-card, .review-item, .ruk_card, [class*="review_item"], .testimonial-card, .testimonial-item');
    
    reviewItems.forEach(item => {
      // Make sure interactive elements are initially not focusable
      const interactiveElements = item.querySelectorAll('a, button, input, [tabindex]');
      interactiveElements.forEach(el => {
        if (!el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
          el.setAttribute('tabindex', '-1');
        }
      });
    });
    
    // If the review section is inside another section that's already enhanced, 
    // we don't need to create another wrapper
    if (section.closest('[data-a11y-section-enhanced="true"]')) {
      return;
    }
    
    // If no wrapper exists yet, create one
    if (!section.querySelector('.section-keyboard-wrapper')) {
      // Find heading to use as label
      let sectionHeading = section.querySelector('h1, h2, h3, h4, .sd-heading, .headline, [class*="title"]');
      const headingText = sectionHeading ? sectionHeading.textContent.trim() : 'Reviews section';
      
      // Create the wrapper element for the section
      const wrapper = document.createElement('div');
      wrapper.classList.add('section-keyboard-wrapper');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', `${headingText}, press Enter to explore reviews`);
      
      // Setup the styling for focus state
      wrapper.style.position = 'absolute';
      wrapper.style.inset = '0';
      wrapper.style.zIndex = '2'; // Very low z-index so it doesn't block product links
      wrapper.style.outline = 'none';
      wrapper.style.pointerEvents = 'none';
      
      // Append the wrapper to the section
      section.appendChild(wrapper);
      
      // Mark section as enhanced
      section.setAttribute('data-a11y-section-enhanced', 'true');
      
      // Style focus state of the section
      wrapper.addEventListener('focus', function() {
        section.classList.add('section-keyboard-focus');
        section.style.outline = '3px solid #5F9353';
        section.style.outlineOffset = '4px';
      });
      
      wrapper.addEventListener('blur', function() {
        section.classList.remove('section-keyboard-focus');
        section.style.outline = '';
        section.style.outlineOffset = '';
      });
    }
  });
  
  // Add global style for section focus
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .section-keyboard-focus {
      position: relative;
      z-index: 2;
    }
    
    .section-focus {
      position: relative;
      z-index: 2;
    }
    
    .section-keyboard-wrapper {
      pointer-events: none !important;
      z-index: 2 !important;
    }
    
    .productcard:focus-within, 
    .product-card:focus-within,
    .product:focus-within {
      outline: 3px solid #5F9353;
      outline-offset: 4px;
      border-radius: 4px;
      position: relative;
      z-index: 20;
    }
    
    .productcard:focus-within .add-to-cart-button,
    .product-card:focus-within .add-to-cart-button,
    .product:focus-within button[type="submit"] {
      display: block !important;
      opacity: 1 !important;
      z-index: 50 !important;
    }
    
    .review-card:focus-within,
    .jdgm-rev:focus-within,
    .testimonial-item:focus-within,
    [class*="review_item"]:focus-within {
      outline: 3px solid #5F9353;
      outline-offset: 4px;
      border-radius: 4px;
      position: relative;
      z-index: 30;
    }
  `;
  // Make the button of the slides clickable with space key
  document.body.appendChild(styleElement);

  const allButtons = document.querySelectorAll('button, a.s-sd-button-primary-mt-5, [class*="button"], [role="button"]');
  allButtons.forEach(button => {
    if (!button.hasAttribute('data-keyboard-enhanced')) {
      button.setAttribute('data-keyboard-enhanced', 'true');
      
      button.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.click();
        }
      });
    }
  });
}); 